/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Fc_4Inputs */

const en_fc_vs_who_fc_4 = /** @type {(inputs: Fc_Vs_Who_Fc_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`want to automate or script your edits`)
};

/**
* | output |
* | --- |
* | "want to automate or script your edits" |
*
* @param {Fc_Vs_Who_Fc_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_fc_4 = /** @type {((inputs?: Fc_Vs_Who_Fc_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Fc_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_fc_4(inputs)
});
export { fc_vs_who_fc_4 as "fc.vs.who.fc.4" }